<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control"
                         id="fromDate" v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control"
                         id="toDate" v-model="toDate"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">Vendor</label>
              <Dropdown
                v-if="!setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :showClear="true"
              />
              <Dropdown
                v-if="setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :disabled="true"
              />
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button label="Search" class="p-button-raised p-button-rounded"
                      type="submit" lable="Search" @click.prevent="searchDelivery"></Button>
            </div>
            <div class="p-field p-col-12">
              <a href="#" @click.prevent="exportCSV()" v-if="this.pendingDeliveryLists.length > 0">
                <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
              </a>
            </div>

          </div>

          <Dialogs header="Reason" :visible.sync="ecommerceStatusDialog"
                   :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="col-md-12">
              <label for="reason" class="col-md-4 control-label">Reason</label>
              <div class="form-group col-md-8">
                <textarea class="form-control" rows="5" v-model="reason"></textarea>
              </div>
            </div>
            <template #footer>
              <Button class="btn btn-danger" type="submit" @click.prevent="updateOrderStatus">Send</Button>
              <Button class="btn btn-success" type="submit" @click.prevent="cancel">Cancel</Button>
            </template>
          </Dialogs>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <DataTable :value="pendingDeliveryLists" dataKey="id" ref="dt"
                       :paginator="true" class="p-datatable-gridlines"
                       :rows="10" :filters="filters">
              <Column header="S.N" headerStyle="width: 3rem">
                <template #body="sl">{{ sl.index + 1 }}</template>
              </Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="deliveryDateNepali"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['deliveryDateNepali']"/>
                </template>
              </Column>
              <Column header="Del Code" :sortable="true" field="orderCode" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['orderCode']"/>
                </template>
              </Column>
              <Column header="Customer" :sortable="true" field="customerName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['customerName']"/>
                </template>
              </Column>
              <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
                </template>
              </Column>
              <Column header="Contact" :sortable="true" field="primaryContact" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['primaryContact']"/>
                </template>
              </Column>

              <Column header="Amount" bodyStyle="text-align: right" :sortable="true" field="billAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['billAmount']"/>
                </template>
              </Column>
              <Column header="Del Charge" bodyStyle="text-align: right" :sortable="true" field="deliveryChargeAmount"
                      filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-model="slotProps.data['deliveryChargeAmount']"
                             @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['deliveryChargeAmount']"/>
                </template>
              </Column>

              <Column field="orderStatus" header="Status" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['orderStatus']"/>
                </template>

              </Column>
              <!-- <Column field="paymentStatus" header="Pay Status" filterMatchMode="contains">
               <template #filter>
                     <InputText type="text" class="p-column-filter" v-model="filters['paymentStatus']" />
                 </template>

             </Column> -->
              <Column header="Store" bodyStyle="text-align: right" :sortable="true" field="storeName"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['storeName']"/>
                </template>
              </Column>

              <Column header="Remarks" field="remarks">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['remarks']"/>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>

    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import Checkbox from 'primevue/checkbox'
import Tooltip from 'primevue/tooltip'
import Button from 'primevue/button'

export default {
  name: 'deliveryReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      loading: false,
      dialogShow: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      idsForOrderPrint: [],
      selectedSalesOrderId: null,
      ecommerceStatusDialog: false,
      reason: '',
      ecommerceStatusData: '',
      paymentStatusData: '',
      inventoryHeaderId: null,
      assignedTo: null,
      deliveryCharge: null,
      setWarehouseData: false,
      warehouseId: null,
      // [{label: 'In Stock', value: 'INSTOCK'},{label: 'Low Stock', value: 'LOWSTOCK'},{label: 'Out of Stock', value: 'OUTOFSTOCK'}]
      statuses: [{label: 'Processing', value: 'Processing'}, {label: 'Hold', value: 'Hold'}, {
        label: 'Completed',
        value: 'Completed'
      }, {label: 'Cancel', value: 'Cancelled'},
        {label: 'Assigned To Rider', value: 'AssignedToRider'}, {
          label: 'Received By Store',
          value: 'ReceivedByStore'
        }, {label: 'Received By Rider', value: 'ReceivedByRider'}],
      statusesPay: [{label: 'Paid', value: 'Paid'}, {label: 'Unpaid', value: 'Unpaid'}, {
        label: 'HalfPayment',
        value: 'HalfPayment'
      }],
      userList: []
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.warehouseList()
    this.setWarehouse()
  },
  computed: {
    pendingDeliveryLists() {
      return this.$store.state.sales.pendingDeliveryLists
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  methods: {
    async searchDelivery() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        warehouse: this.id
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadPendingDeliveryLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.pendingDeliveryList = []
      } else {
        this.pendingDeliveryList = resp.data.data
      }
    },
    showReasonDialog(data) {
      this.inventoryHeaderId = data.id
      this.ecommerceStatusData = data.orderStatus
      this.paymentStatusData = data.paymentStatus
      if (data.orderStatus === 'Hold' || data.orderStatus === 'Cancelled') {
        this.ecommerceStatusDialog = true
        this.inventoryHeaderId = data.id
        this.ecommerceStatusData = data.orderStatus
        this.paymentStatusData = data.paymentStatus
      }
      if (data.orderStatus === 'Completed') {
        this.reason = '-'
        this.deliveryCharge = data.deliveryChargeAmount
        this.updateOrderStatus()
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    showDialogForRemarks(data) {
      if (data.riderRemarks !== null) {
        this.reason = data.riderRemarks
        this.inventoryHeaderId = data.id
        this.ecommerceStatusData = data.orderStatus
        this.paymentStatusData = data.paymentStatus
        this.ecommerceStatusDialog = true
        this.assignedTo = data.assignedTo
        this.deliveryCharge = data.deliveryChargeAmount
      }
    },
    async updateOrderStatus() {
      if (this.assignedTo === null) {
        this.assignedTo = 0
      }
      let data = {
        inventoryHeaderId: this.inventoryHeaderId,
        statusType: this.ecommerceStatusData,
        reason: this.reason,
        assignedTo: this.assignedTo,
        paymentStatus: this.paymentStatusData,
        deliveryCharge: this.deliveryCharge
      }
      let resp = await this.$store.dispatch('updateStatusByAdmin', data)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.ecommerceStatusDialog = false
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case 'Processing':
          return 'Processing'

        case 'Hold':
          return 'Hold'

        case 'Completed':
          return 'Completed'

        case 'Cancel':
          return 'Cancelled'

        case 'AssignedToRider':
          return 'Assigned To Rider'

        case 'ReceivedByStore':
          return 'Received By Store'

        case 'ReceivedByRider':
          return 'Received By Rider'

        default:
          return 'NA'
      }
    },
    getPayStatusLabel(payStatus) {
      switch (payStatus) {
        case 'Paid':
          return 'Paid'

        case 'Unpaid':
          return 'Unpaid'

        case 'HalfPayment':
          return 'Half Paid'

        default:
          return 'NA'
      }
    },
    async updateAssignedToUser(data) {
      if (data.assignedTo === undefined) {
        data.assignedTo = 0
      }
      let userData = {
        inventoryHeaderId: data.id,
        statusType: data.orderStatus,
        reason: data.remarks,
        assignedTo: data.assignedTo,
        paymentStatus: data.paymentStatus,
        deliveryCharge: data.deliveryChargeAmount,
        billAmount: data.billAmount
      }
      let resp = await this.$store.dispatch('updateStatusByAdmin', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        // this.ecommerceStatusDialog = false
      }
    },
    async updatePaymentStatus(data) {
      let userData = {
        inventoryHeaderId: data.id,
        statusType: data.orderStatus,
        reason: data.riderRemarks,
        assignedTo: data.assignedTo,
        paymentStatus: data.paymentStatus,
        deliveryCharge: data.deliveryChargeAmount
      }
      let resp = await this.$store.dispatch('updateStatusByAdmin', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        // this.ecommerceStatusDialog = false
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportForRequest/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/vendorDeliveryReport' + '/' + this.$store.getters.fyId + '/' + this.$store.getters.warehouseId.id + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'vendorDeliveryReport.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesOrder' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesOrder.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    expexportToPdfOrderortToPdf() {
      if (this.selectedSalesOrderId !== null) {
        this.selectedSalesOrderId.forEach(salesOrderId => this.idsForOrderPrint.push(salesOrderId.id))
      }
      if (this.idsForOrderPrint.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one order!', life: 10000})
        return
      }
      if (this.idsForOrderPrint.length > 5) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry Cannot more then 5 order!', life: 10000})
        return
      }
      axios({
        url: globalKey + '/fileDownload/printOrderForKritiCraft/' + this.$store.getters.organisationId + '/' +
          this.$store.getters.userId + '/' + this.idsForOrderPrint,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'Order No' + this.idsForOrderPrint + '.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      this.idsForOrderPrint = []
      this.selectedSalesOrderId = null
    },
    columnNames() {
      for (let i = 0; i < this.$refs.dt.columns.length; i++) {
        this.columnList += this.$refs.dt.columns[i].header + ','
      }
    },
    editSalesOrder(data) {
      this.$router.push({name: 'Sales Order', params: {salesOrder: data}})
    },
    selectedSalesOrder(data) {
      // this.selectedSalesOrderId.push(data.id)
      if (!this.idsForOrderPrint.includes(data)) {
        this.idsForOrderPrint.push(data)
      }
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteSalesOrder', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.dialogShow = false
    },
    cancel(data) {
      this.dialogShow = false
      this.ecommerceStatusDialog = false
      this.reason = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.pendingDeliveryList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    InputMask,
    Dropdown,
    Dialogs,
    Checkbox,
    Tooltip,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// pendingDeliveryReport.vue?3bec0e38